import {MIN_SEARCH_LENGTH} from '../../consts';

import {FIELD_NAME, FIELD_ADDRESS, FIELD_DESCRIPTION, FIELD_ROLE} from './consts';
import type {AccountFormFieldTypes} from './types';

export const shouldShowPotentialAccounts = (
    name?: string | null,
    description?: string | null,
    address?: string | null,
    role?: string | null
) => {
    return (
        (name && name.length >= MIN_SEARCH_LENGTH) ||
        (description && description.length >= MIN_SEARCH_LENGTH) ||
        (address && address.length >= MIN_SEARCH_LENGTH) ||
        (role && role.length >= MIN_SEARCH_LENGTH)
    );
};

export const shouldAllowCreate = (
    isTemporary: boolean,
    name?: string | null,
    address?: string | null
) => {
    return (
        !isTemporary &&
        ((name && name.length >= MIN_SEARCH_LENGTH) ||
            (address && address.length >= MIN_SEARCH_LENGTH))
    );
};

export const handleKeyboardNavigation = (
    e: React.KeyboardEvent,
    hasRoleField: boolean,
    hasDescriptionField: boolean,
    currentField: AccountFormFieldTypes,
    addressRef: React.RefObject<HTMLInputElement | null | undefined | null>,
    descriptionRef: React.RefObject<HTMLInputElement | null | undefined | null>,
    nameRef: React.RefObject<HTMLInputElement | null | undefined | null>,
    roleRef: React.RefObject<HTMLInputElement | null | undefined | null>
) => {
    switch (e.key) {
        case 'ArrowDown':
            if (currentField === FIELD_NAME) {
                if (hasDescriptionField) {
                    descriptionRef.current?.focus();
                } else {
                    addressRef.current?.focus();
                }
            }
            if (currentField === FIELD_DESCRIPTION) addressRef.current?.focus();
            if (currentField === FIELD_ADDRESS) {
                if (hasRoleField) {
                    roleRef.current?.focus();
                } else {
                    nameRef.current?.focus();
                }
            }
            if (currentField === FIELD_ROLE) {
                nameRef.current?.focus();
            }
            break;
        case 'ArrowUp':
            if (currentField === FIELD_NAME) {
                if (hasRoleField) {
                    roleRef.current?.focus();
                } else {
                    addressRef.current?.focus();
                }
            }
            if (currentField === FIELD_DESCRIPTION) nameRef.current?.focus();
            if (currentField === FIELD_ADDRESS) {
                if (hasDescriptionField) {
                    descriptionRef.current?.focus();
                } else {
                    nameRef.current?.focus();
                }
            }
            if (currentField === FIELD_ROLE) {
                addressRef.current?.focus();
            }
            break;
    }
};
